import { createInsertNodeAPI } from './api';
export var contentInsertionPlugin = function contentInsertionPlugin(_ref) {
  var _api$analytics;
  var api = _ref.api;
  return {
    name: 'contentInsertion',
    actions: createInsertNodeAPI(api === null || api === void 0 ? void 0 : (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)
  };
};